import _ from "ES/lib/lodash";
import React from "ES/lib/react";
import esUtils from "ES/utils/esUtils";
import FormMixin from "react-loose-forms";
import RadioServiceMixin from "ES/lib/react-pubsub-via-radio.js/RadioServiceMixin";
import ModalWrap from "../../widgets/ModalWrap";
import ComplianceMessageModal from "./ComplianceMessageModal";

const SendButton = React.createClass({
    render () {
        let {
            is_sending
        } = this.props;

        let size = 30;
        is_sending = !!is_sending;

        let className = "btn btn-default btn-flat";

        if (is_sending) {
            className += " disabled";
        }

        return (
            <button type="submit" className={className} style={{
                position: "absolute",
                bottom: "10px",
                right: "10px",

                height: size + "px",
                width: size + "px",
                lineHeight: size + "px",
                borderRadius: size + "px",
                fontSize: "15px",
                padding: "0px"
            }}>
                <i className={"fa " + (is_sending ? "fa-spinner fa-spin" : "fa-send")}/>
                <span className="sr-only">Send</span>
            </button>
        );
    }
});

let MessageSendForm = React.createClass({
    mixins: [FormMixin],
    getInitialValuesSourceVersion: function (props) {
        return props.version_key;
    },
    getInitialValues: function () {
        return {
            message: ""
        };
    },
    buildSchema: function () {
        let is_sending = !!this.props.is_sending;
        return {
            message: {
                type: "textarea",
                placeholder: "Type message here...",
                disabled: is_sending,
                rows: 5,
                validate: function (v) {
                    return esUtils.isBlank(v)
                        ? "Please enter a message"
                        : true;
                }
            }
        };
    },
    render: function () {
        let fields = this.Form_buildSchema();
        let buildInput = this.Form_buildInput;
        let error = _.get(this, ["state", "errors", "message"]);
        let ajax_error = this.props.error;
        let is_sending = !!this.props.is_sending;

        return (
            <form
                className="MP-MessageSendForm"
                onSubmit={this.Form_onSubmit}
            >
                <div className={"form-group" + (error ? " has-error" : "")}>
                    <div style={{position: "relative"}}>
                        {buildInput(fields.message)}
                        <SendButton is_sending={is_sending}/>
                    </div>
                    {error
                        ? <span className="help-block">{error}</span>
                        : null
                    }
                    {ajax_error
                        ? <span className="text-danger">Failed to send: {ajax_error}</span>
                        : null
                    }
                </div>
            </form>
        );
    }
});

export default React.createClass({
    state: {
        show_compliance_confirmation_modal: false
    },
    mixins: [RadioServiceMixin],
    RadioService_setup() {
        return {
            Marketplace_sendMPMessages: {
                key() {
                    let {eid, sid} = this.props;
                    return eid + "|" + sid;
                },
                on: {
                    succeeded(message) {
                        if (_.isFunction(this.props.onSentMessage)) {
                            this.props.onSentMessage(message);
                        }
                    },
                    failed(message) {
                        // show a popup for compliance, include the initials, and resubmit the message form
                        if (_.startsWith(message, "CONTACT")) {
                            this.setState({
                                show_compliance_confirmation_modal: true
                            });
                        }
                    }
                }
            }
        };
    },
    __toggleMessageComplianceModal: function() {
        this.setState({
            show_compliance_confirmation_modal: !this.state.show_compliance_confirmation_modal
        });
    },
    __onSubmit: function (data) {
        this.setState({
            message: data.message
        });
        this.RadioService_callService("Marketplace_sendMPMessages", {
            sid: this.props.sid,
            eid: this.props.eid,
            message: data.message,
            skip_compliance: false
        });
    },
    __onSubmitWithCompliance: function (data) {
        this.RadioService_callService("Marketplace_sendMPMessages", data);
    },
    render() {
        let {
            sid,
            eid,
            thread,
            event
        } = this.props;

        let ajax = this.state.Marketplace_sendMPMessages;
        let sent_messages = this.state.sent_messages || [];
        let version_key = sid + "," + (eid) + "," + _.size(thread);
        // calculate the commission (accounting for nulls and bad data)
        let commission = 0;
        if (!_.isNull(_.get(event, ["key_values", "MP_ESPEAKERS_COMMISSION"]))) {
            commission += parseFloat(_.get(event, ["key_values", "MP_ESPEAKERS_COMMISSION"], "0.1"));
        }
        if (!_.isNull(_.get(event, ["key_values", "MP_WHITELABEL_COMMISSION"]))) {
            commission += parseFloat(_.get(event, ["key_values", "MP_WHITELABEL_COMMISSION"], "0.0"));
        }
        commission *= 100;

        return <div>
            <div>
                <MessageSendForm
                    version_key={version_key}
                    onSubmit={this.__onSubmit}
                    is_sending={ajax.waiting}
                    error={ajax.error ? ajax.error + "" : null}
                />
                {_.size(sent_messages) > 0 && !ajax.waiting && !ajax.error
                    ? <p className="text-success" style={{textAlign: "right", marginRight: "2em"}}>Message sent.</p>
                    : null
                }
            </div>
            {this.state.show_compliance_confirmation_modal && <ModalWrap body={<ComplianceMessageModal
              onClose={this.__toggleMessageComplianceModal}
              onAcceptCompliance={this.__onSubmitWithCompliance}
              message={this.state.message}
              sid={sid}
              eid={eid}
              commission={commission}
            />} />}
        </div>;
    }
});


// WEBPACK FOOTER //
// ./src/components/marketplace/MyMessagesTab/MessageForm.js